import React from 'react';

const Button = ({
    children,
    variant = 'primary',
    size = 'md',
    icon: Icon,
    disabled = false,
    className = '',
    loading = false,
    ...props
}) => {
    const baseStyles = 'inline-flex items-center justify-center font-semibold rounded-xl transition-all duration-150 focus:outline-none focus:ring-2 focus:ring-offset-2 active:scale-95 cursor-pointer select-none shadow-sm disabled:cursor-not-allowed disabled:opacity-60 disabled:transform-none disabled:active:scale-100';

    const variants = {
        primary: 'bg-[#1a3884] text-white hover:bg-[#0f255c] active:bg-[#0a1b42] focus:ring-[#1a3884]/50 border border-[#1a3884]/20 hover:shadow-md',
        secondary: 'bg-white dark:bg-[#00152e] text-gray-700 dark:text-gray-200 border border-gray-200 dark:border-[#1a3884]/50 hover:bg-gray-50 dark:hover:bg-[#1a3884]/20 focus:ring-[#1a3884]/30',
        outline: 'border border-gray-300 dark:border-[#1a3884]/40 text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-[#1a3884]/15 focus:ring-[#1a3884]/30',
        danger: 'bg-rose-600 text-white hover:bg-rose-700 active:bg-rose-800 focus:ring-rose-500/50',
        success: 'bg-emerald-600 text-white hover:bg-emerald-700 active:bg-emerald-800 focus:ring-emerald-500/50',
    };

    const sizes = {
        sm: 'px-3 py-1.5 text-xs gap-1.5',
        md: 'px-4 py-2.5 text-sm gap-2',
        lg: 'px-6 py-3 text-base gap-2.5',
    };

    return (
        <button
            className={`${baseStyles} ${variants[variant] || variants.primary} ${sizes[size] || sizes.md} ${className}`}
            disabled={disabled || loading}
            {...props}
        >
            {Icon && <Icon className="w-4 h-4 mr-1.5 shrink-0" />}
            {children}
        </button>
    );
};

export default Button;
